import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Pagination,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ErrorOutline } from "@mui/icons-material";
import axios from "axios";
import CallActivityGraph from "../reusables/CallActivotyGraph";
import RecentCalls from "./RecentCalls";

const Home = () => {
  const navigate = useNavigate();
  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const [calls, setCalls] = useState([]);


  const getCalls = async () => {
    setLoader(true);
    try {
      let calls_ = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "call/get-calls",
        {
          organization_id: JSON.parse(localStorage.getItem("organization"))
            .orgId.S,
        }
      );
      let calls__ = calls_.data.calls;
      const dummyCall = {
        startTime: { N: '1733443200000' }, // Current timestamp for callTime
        toNumber: { S: "234567890" }, // Random toNumber
        fromNumber: { S: "+0987654321" }, // Random callerNumber
        action: { S: "Answered" }, // Example action
        actionDetails: { S: "some details" }, // Example action details
        voicemail: { S: "Yes" }, // Example voicemail status
        callId: { S: "dummy12345" }, // Example unique call ID
      };

      // const callsWithDummy = [dummyCall, ...calls__];
      const callsWithDummy = calls__
      const formattedCalls = callsWithDummy.map((call) => ({
        callTime: call.startTime?.N || "N/A", // Use "N/A" if callTime is missing
        toNumber: call.toNumber?.S || "N/A", // Fallback to "N/A" if toNumber is missing
        callerNumber: call.fromNumber?.S || "N/A", // Fallback
        action: call.action?.S || "N/A", // Fallback
        actionDetails: call.action_details?.S || "N/A", // Fallback
        voicemail: call.has_vm?.BOOL ? 'Yes' : "No", // Default to "No"
        link: "/dashboard/call-details/" + call.callId?.S, // Default link
      }));
      setCalls(formattedCalls);

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        setErrorMsg(
          error.response.data.error + " " + error.response.data?.message
        );
      }
      setLoader(false);
    }
  };

  useEffect(() => {
    getCalls();
  }, []);



  return (
    <div className="pt-7 px-4">
      <div className="lg:text-[17px] text-[15px] font-semibold">Dashboard</div>

      <div className="bg-white rounded-[13px] relative h-[400px] mb-4 p-4">
        <CallActivityGraph call_data={calls} />
      </div>

      {err_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2 font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
        </div>
      )}

      {loader && <CircularProgress size={"1.2rem"}   sx={{ color: "#605BFF", animationDuration: "0.7s", }} />}

      <div className="bg-white rounded-[13px] w-full relative">
        {calls && calls.length > 0 ? (
          <>
            <RecentCalls navigate={navigate} calls={calls}   />

         
          </>
        ) : (
          <div className="p-4 text-[14px]">
            <div className="cursor-pointer text-[16px] font-semibold text-[#030229] mb-3 ">
              Recent Calls
            </div>
            You don't have any calls yet. In the future, this page will help you track your call volume.
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
